import React from 'react';
import Header from './DataTableComponents/Header';

export default class DataTable2 extends React.Component {
	constructor(props) {
		super(props);

		const data = this.props.data || [];

		this.state = {
			data: data || [],
			loading: false,
			initialized: false
		};

		this.loadData = this.loadData.bind(this);
	}

	componentDidMount() {
		if (!this.state.data || this.state.data.length === 0) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			this.state.initialized &&
			!prevState.initialized &&
			typeof this.props.onInit === 'function'
		) {
			this.props.onInit();
		}

		if (this.props.data && this.state.data.length !== this.props.data.length) {
			this.setState({ data: this.props.data });
		}

		if (
			prevProps.endpoint !== this.props.endpoint ||
			prevProps.totalRecords !== this.props.totalRecords ||
			prevProps.isActionComplete !== this.props.isActionComplete ||
			JSON.stringify(prevProps.params) !== JSON.stringify(this.props.params)
		) {
			this.loadData();
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
		}
	}

	render() {
		// console.log('DataTable2 - Props', this.props);
		return (
			<div className="DataTable2 mb-2">
				<table>
					<thead>
						<tr>
							{this.props.columns.map((column) => (
								<th
									key={column.displayName}
									style={
										column.colNum === 1 ? (
											{ width: `${column.colWidth}%` }
										) : column.colNum === 2 ? (
											{ width: `${column.colWidth}%` }
										) : column.colNum === 3 ? (
											{ width: `${column.colWidth}%` }
										) : column.colNum === 4 ? (
											{ width: `${column.colWidth}%` }
										) : column.colNum === 5 ? (
											{ width: `${column.colWidth}%` }
										) : (
											''
										)
									}
								>
									<Header
										column={column}
										onChangeSortOrder={
											column.isSortable === false ? (
												''
											) : (
												this.props.onChangeSortOrder
											)
										}
										sortOrder={this.props.sortOrder}
										sortColumn={this.props.sortColumn}
									/>
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{this.state.data &&
							this.state.data.map((d) => {
								return this.props.rowRenderer(d);
							})}
					</tbody>
				</table>
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
			</div>
		);
	}

	/**
   * Change Handlers
   */

	/**
   * Helper Functions
   */

	loadData() {
		this.setState({ loading: true });

		$.ajax({
			type: 'GET',
			url: this.props.endpoint,
			data: this.props.params
		}).done((payload) => {
			const { data, meta } = payload;
			this.setState({ data: data, loading: false, initialized: true }, () => {
				this.props.onChange &&
					this.props.onChange({ target: { name: 'meta', value: meta } });
			});
		});
	}
}
